import React from 'react';
import { type CategoryDescriptionComponentProps } from 'content/CategoryDescription';
import CategoryDescriptionBlock from 'libs/sanity/content/Blocks/CategoryDescriptionBlock';
import BlockGridWrapper from 'components/wrappers/BlockGridWrapper';
import styled from 'libs/styled';

interface CategoryDescriptionModuleProps {
    data: {
        block: CategoryDescriptionComponentProps;
    };
}

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
`;

const ContentSlot = styled('div')``;

const CategoryDescriptionModule: React.FC<CategoryDescriptionModuleProps> = (data) => {
    const { data: moduleData } = data;
    const blockData = moduleData?.block || moduleData;
    const hasHeading = Boolean(blockData?.heading);
    const hasRichText = Array.isArray(blockData?.richText) && blockData.richText.length > 0;
    const hasButtons = Array.isArray(blockData?.buttons) && blockData.buttons.length > 0;

    if (!hasHeading && !hasRichText && !hasButtons) {
        return null;
    }

    return (
        <ModuleWrapper className="CategoryDescriptionModule">
            <BlockGridWrapper>
                <ContentSlot gridColumn={['1 / -1', null, null, null, '1 / 13']}>
                    <CategoryDescriptionBlock data={blockData} />
                </ContentSlot>
            </BlockGridWrapper>
        </ModuleWrapper>
    );
};
export default CategoryDescriptionModule;
